import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type ItemsRequiredApplyChoice = 'default' | 'instance' | 'cancel';

export interface ItemsRequiredApplyDialogData {
    title?: string;
    message?: string;
}

@Component({
    selector: 'app-items-required-apply-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
    template: `
  <div class="p-16" style="max-width: 640px;">
    <div class="g-just-flex gap-10" style="align-items:center;">
      <mat-icon>rule</mat-icon>
      <h2 class="m-0" style="font-size:18px;">{{ data?.title || 'Apply items required changes' }}</h2>
    </div>

    <p class="subtitle-text-color-2" style="margin-top:12px; line-height:20px;">
      {{ data?.message || 'You changed the items required. Do you want to update the default configuration for this service code, or apply only to this ServiceRequest?' }}
    </p>

    <div class="g-just-flex gap-12" style="justify-content:flex-end; flex-wrap:wrap; margin-top:18px;">
      <button mat-stroked-button (click)="choose('cancel')">Cancel</button>
      <button mat-flat-button color="primary" (click)="choose('instance')">Apply only to this ServiceRequest</button>
      <button mat-flat-button color="warn" (click)="choose('default')">Apply as default for this code</button>
    </div>
  </div>
  `
})
export class ItemsRequiredApplyDialogComponent {
    readonly data = inject(MAT_DIALOG_DATA, { optional: true }) as ItemsRequiredApplyDialogData | null;
    private readonly dialogRef = inject(MatDialogRef<ItemsRequiredApplyDialogComponent>);

    choose(choice: ItemsRequiredApplyChoice) {
        this.dialogRef.close(choice);
    }
}
